import {Notification} from 'element-ui'
import {merge} from 'lodash'
import bus from '@utils/bus'

function _success (options) {
  const defaultOptions = {
    title: 'Sucesso!',
    message: 'Os dados foram gravados',
    offset: 50,
    duration: 3000
  }
  options = merge(defaultOptions, options)
  if (options.hasOwnProperty('hideLoader') && options.hideLoader) {
    bus.$emit('hide-loader')
  }
  Notification.success(options)
}

function _error (options) {
  const defaultOptions = {
    title: 'Atenção!',
    message: 'Ocorreu um problema na sua solicitação',
    offset: 50,
    duration: 3000
  }
  options = merge(defaultOptions, options)
  if (options.hasOwnProperty('hideLoader') && options.hideLoader) {
    bus.$emit('hide-loader')
  }
  Notification.error(options)
}

export const success = _success
export const error = _error



// WEBPACK FOOTER //
// ./src/app/services/notifyService.js